import React from "react";
import { Table } from "antd";
import "antd/dist/antd.css";
import moment from "moment";

const SalesReportTable = ({ data }) => {
  console.log(data);
  const columns = [
    {
      title: "Order ID",
      dataIndex: "orderId",
      key: "orderId",
    },
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
    },
    {
      title: "Product Quantity",
      dataIndex: "productQuantity",
      key: "productQuantity",
    },
    {
      title: "Product price",
      dataIndex: "mrp",
      key: "mrp",
    },
    {
      title: "Total Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
      render: (createdAt) => (
        <div>
          <div className="text-sm">
            {moment(createdAt).format("DD-MMM-YYYY")}
          </div>
          <div className="text-xs">{moment(createdAt).format("h:mm A")}</div>
        </div>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      scroll={{ x: "true" }}
      columns={columns}
      rowKey="orderId"
    />
  );
};

export default SalesReportTable;
